var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarkerMeteo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49396 22.3721C8.04996 22.2221 7.61796 22.0441 7.19596 21.8401V7.54007H8.49396V22.3721ZM8.89996 6.06807C8.89996 6.47807 8.56596 6.81207 8.15596 6.81207H7.45396C7.04396 6.81207 6.70996 6.47807 6.70996 6.06807V5.36607C6.70996 4.95607 7.04396 4.62207 7.45396 4.62207H8.15596C8.56596 4.62207 8.89996 4.95607 8.89996 5.36607V6.06807ZM13.286 14.6201L10.846 14.9541V8.67607L13.286 9.01007V14.6201ZM16.588 14.1661L14.17 14.4981V9.13207L16.588 9.46407V14.1661ZM19.868 13.3881C19.868 13.5761 19.73 13.7361 19.542 13.7621L17.472 14.0461V9.58607L19.542 9.87007C19.728 9.89607 19.868 10.0541 19.868 10.2441V13.3901V13.3881Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerMeteo);
export default __webpack_public_path__ + "static/media/markerMeteo.94f0473ba392627919c1a77ae89f0961.svg";
export { ForwardRef as ReactComponent };